<template lang="pug">
  div(class="branding")
    div(class="branding-inner")
      a(class="branding-logo" href="http://www.dunloptyres.co.zm/")
        img(src="/static/logo.jpg")
      div(class="branding-home")
        a(class="branding-home-link" href="http://www.dunloptyres.co.zm/")
          span Go to&nbsp;
          span(class="red") dunloptyres.co.zm
          div(class="branding-home-image")
            img(src="@/assets/images/car.png")
</template>

<script>
import logo from '@/assets/images/logo.svg'
export default {
  name: 'branding',
  components: {
    logo
  }
}
</script>

<style lang="stylus">
.branding
  position: fixed;
  top: 0
  left: 0
  z-index: 5
  @media (max-height: 800px)
    font-size: 0.8em
  &-logo
    display: block
    position: relative;
    filter: drop-shadow(0.5em 0.5em 1em rgba(0,0,0,0.57));
    width: 20em
    &:before
      content: ''
      position: absolute;
      right: -1em
      top:0
      bottom: 0
      left: 0
      background: #FFDD00
      transform: skewX(-18deg)
      transform-origin: right bottom
    & > img
      position: relative;
      transform: translateX(0)
      width: 100%
  &-home
    margin-top: 1em
    padding-left: 2em
    position: relative
    width: 17em
    filter: drop-shadow(0.5em 0.5em 1em rgba(0,0,0,0.57));
    &:before
      content: ''
      position: absolute;
      right: -1em
      top:0
      bottom: 0
      left: -5em
      background: #FFDD00
      transform: skewX(-18deg)
      transform-origin: right bottom
    &-link
      text-decoration: none
      color: inherit
      text-transform: uppercase
      display: flex
      align-items: center;
      position: relative;
      & span
        font-size: 0.8em
      &:hover
        & .branding-home-image
          & > img
            transform: translateX(1em)
    &-image
      flex: 0 0 3em
      & > img
        width: 100%
        transition: transform 200ms ease
.red
  color: red
</style>



// WEBPACK FOOTER //
// src/components/branding.vue